import React from 'react';

function Footer() {

  return (
	    <div className="top1"  >
      			
      			
      			<div className="foot-right">
      				<h3>Copyrights © 2020 Tianjin Institute of Industrial Biotechnology, Chinese Academy of Sciences </h3>
					<h6>Recommended Browsers: Chrome, Firefox, Edge</h6>
      			</div>
      	</div>
	);
  
}


  



export default Footer;